module.exports = __webpack_public_path__ + "ge.080272a7.svg";